<template>
  <div>
    <div>
      <h1 class="mr-sm-4 header-tablepage">Branch Style</h1>
    </div>
    <div class="title-tabs mt-3">Branch Style</div>
    <b-container class="no-gutters bg-white">
      <div class="py-3">
        <b-row>
          <b-col lg="6" md="6" sm="12" xs="12">
            <InputText
              textFloat="Name"
              placeholder="Name"
              type="text"
              name="branch_name_en"
              v-model="form.branch_style_name"
              :isValidate="$v.form.branch_style_name.$error"
              :v="$v.form.branch_style_name"
              isRequired
            />
          </b-col>

          <b-col lg="6" md="6" sm="12" xs="12">
            <InputText
              textFloat="Sort Order"
              placeholder="Sort Order"
              type="number"
              name="sort_order"
              v-model="form.sort_order"
            />
          </b-col>
          <b-col lg="6" md="6" sm="12" xs="12">
            <b-form-checkbox
              id="is_default"
              name="is_default"
              v-model="form.is_default"
              :value="1"
              :unchecked-value="0"
            >
              Default
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <div class="no-gutters bg-white mt-3 py-2 px-3">
      <b-form-checkbox
        switch
        v-model="form.status"
        class="radio-active"
        value="1"
        unchecked-value="0"
        size="lg"
      >
        <span class="ml-2 main-label">{{
          form.status ? "Active" : "Inactive"
        }}</span>
      </b-form-checkbox>
    </div>
    <FooterAction
      routePath="/setting/branch-setting/branch-style"
      @submit="save()"
    />
  </div>
</template>
<script>
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  components: {},
  data() {
    return {
      branchList: [],

      isLoading: true,
      filter: {
        search: "",
        page: 1,
        take: 10,
      },
      pageOptions: [
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "plant_id",
          label: "Plant ID",
          tdClass: "w-25",
        },
        {
          key: "name",
          label: "Branch Name",
          tdClass: "w-25",
        },
        {
          key: "branch_group",
          label: "Branch Group",
          tdClass: "w-25",
        },

        {
          key: "branch_type",
          label: "Type",
          tdClass: "w-25",
        },
      ],
      showBranch: [],
      isBusy: false,
      rows: 0,
      showingTo: 10,
      form: {
        branch_style_id: Number(this.$route.params.id),
        branch_style_name: "",
        sort_order: 0,
        status: 1,
        is_default: 0,
      },
      items: [],
      delete_branch_id: [],
      branchError: false,
    };
  },
  validations: {
    form: {
      branch_style_name: { required },
    },
  },
  async created() {
    this.isLoading = true;

    if (this.form.branch_style_id != 0) return await this.getDetail();
    // this.getBranchList();
  },
  methods: {
    filterPage(filter) {
      this.filter = filter;
      this.getDetail();
    },
    async getDetail() {
      const response = await this.axios(
        `/branch/GetBranchStyle/${this.form.branch_style_id}`,
        this.filter
      );

      this.form = {
        ...response.data.detail,
        branch_style_id: response.data.detail.id,
        branch_style_name: response.data.detail.name,
      };

      // this.getBranchList();
    },

    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getDetail();
    },
    handleSearch(val) {
      this.filter.search = val;
      this.getDetail();
    },
    pagination(page) {
      this.filter.page = page;
      this.getDetail();
    },
    async save() {
      this.branchError = false;
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      let payload = { ...this.form };

      var res;
      if (payload.sort_order == "") {
        payload.sort_order = 0;
      }

      this.$bus.$emit("showLoading");
      if (this.form.branch_style_id == 0) {
        res = await this.axios.post(`/branch/CreateBranchStyle`, payload);
      } else {
        res = await this.axios.put(`/branch/UpdateBranchStyle`, payload);
      }
      this.$bus.$emit("hideLoading");
      if (res.data.result == 1) {
        this.successAlert().then(() => {
          this.$router.push("/setting/branch-setting/branch-style");
        });
      } else this.errorAlert(res.data.message);
    },
  },
};
</script>
